export default "__VITE_ASSET__DYhy$Wly__"